function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire93cd"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire93cd"] = parcelRequire;
}
parcelRequire.register("c34FY", function(module, exports) {
"use strict";

});

parcelRequire.register("dTAXV", function(module, exports) {

$parcel$export(module.exports, "parseFont", () => $a1dd15ff9f265530$export$807478983c0c2e, (v) => $a1dd15ff9f265530$export$807478983c0c2e = v);
$parcel$export(module.exports, "createCanvas", () => $a1dd15ff9f265530$export$cd3d1f114b139967, (v) => $a1dd15ff9f265530$export$cd3d1f114b139967 = v);
$parcel$export(module.exports, "createImageData", () => $a1dd15ff9f265530$export$ad40c38a6f41c9cf, (v) => $a1dd15ff9f265530$export$ad40c38a6f41c9cf = v);
$parcel$export(module.exports, "loadImage", () => $a1dd15ff9f265530$export$fe58198efe02b173, (v) => $a1dd15ff9f265530$export$fe58198efe02b173 = v);
/* globals document, ImageData */ var $a1dd15ff9f265530$export$807478983c0c2e;
var $a1dd15ff9f265530$export$cd3d1f114b139967;
var $a1dd15ff9f265530$export$ad40c38a6f41c9cf;
var $a1dd15ff9f265530$export$fe58198efe02b173;

var $8tby0 = parcelRequire("8tby0");
$a1dd15ff9f265530$export$807478983c0c2e = $8tby0;
$a1dd15ff9f265530$export$cd3d1f114b139967 = function(width, height) {
    return Object.assign(document.createElement("canvas"), {
        width: width,
        height: height
    });
};
$a1dd15ff9f265530$export$ad40c38a6f41c9cf = function(array, width, height) {
    // Browser implementation of ImageData looks at the number of arguments passed
    switch(arguments.length){
        case 0:
            return new ImageData();
        case 1:
            return new ImageData(array);
        case 2:
            return new ImageData(array, width);
        default:
            return new ImageData(array, width, height);
    }
};
$a1dd15ff9f265530$export$fe58198efe02b173 = function(src, options) {
    return new Promise(function(resolve, reject) {
        const image = Object.assign(document.createElement("img"), options);
        function cleanup() {
            image.onload = null;
            image.onerror = null;
        }
        image.onload = function() {
            cleanup();
            resolve(image);
        };
        image.onerror = function() {
            cleanup();
            reject(new Error('Failed to load the image "' + src + '"'));
        };
        image.src = src;
    });
};

});
parcelRequire.register("8tby0", function(module, exports) {
"use strict";
/**
 * Font RegExp helpers.
 */ const $62a9fd43cd94cc3d$var$weights = "bold|bolder|lighter|[1-9]00";
const $62a9fd43cd94cc3d$var$styles = "italic|oblique";
const $62a9fd43cd94cc3d$var$variants = "small-caps";
const $62a9fd43cd94cc3d$var$stretches = "ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded";
const $62a9fd43cd94cc3d$var$units = "px|pt|pc|in|cm|mm|%|em|ex|ch|rem|q";
const $62a9fd43cd94cc3d$var$string = "'([^']+)'|\"([^\"]+)\"|[\\w\\s-]+";
// [ [ <‘font-style’> || <font-variant-css21> || <‘font-weight’> || <‘font-stretch’> ]?
//    <‘font-size’> [ / <‘line-height’> ]? <‘font-family’> ]
// https://drafts.csswg.org/css-fonts-3/#font-prop
const $62a9fd43cd94cc3d$var$weightRe = new RegExp(`(${$62a9fd43cd94cc3d$var$weights}) +`, "i");
const $62a9fd43cd94cc3d$var$styleRe = new RegExp(`(${$62a9fd43cd94cc3d$var$styles}) +`, "i");
const $62a9fd43cd94cc3d$var$variantRe = new RegExp(`(${$62a9fd43cd94cc3d$var$variants}) +`, "i");
const $62a9fd43cd94cc3d$var$stretchRe = new RegExp(`(${$62a9fd43cd94cc3d$var$stretches}) +`, "i");
const $62a9fd43cd94cc3d$var$sizeFamilyRe = new RegExp(`([\\d\\.]+)(${$62a9fd43cd94cc3d$var$units}) *((?:${$62a9fd43cd94cc3d$var$string})( *, *(?:${$62a9fd43cd94cc3d$var$string}))*)`);
/**
 * Cache font parsing.
 */ const $62a9fd43cd94cc3d$var$cache = {};
const $62a9fd43cd94cc3d$var$defaultHeight = 16 // pt, common browser default
;
/**
 * Parse font `str`.
 *
 * @param {String} str
 * @return {Object} Parsed font. `size` is in device units. `unit` is the unit
 *   appearing in the input string.
 * @api private
 */ module.exports = (str)=>{
    // Cached
    if ($62a9fd43cd94cc3d$var$cache[str]) return $62a9fd43cd94cc3d$var$cache[str];
    // Try for required properties first.
    const sizeFamily = $62a9fd43cd94cc3d$var$sizeFamilyRe.exec(str);
    if (!sizeFamily) return; // invalid
    // Default values and required properties
    const font = {
        weight: "normal",
        style: "normal",
        stretch: "normal",
        variant: "normal",
        size: parseFloat(sizeFamily[1]),
        unit: sizeFamily[2],
        family: sizeFamily[3].replace(/["']/g, "").replace(/ *, */g, ",")
    };
    // Optional, unordered properties.
    let weight, style, variant, stretch;
    // Stop search at `sizeFamily.index`
    const substr = str.substring(0, sizeFamily.index);
    if (weight = $62a9fd43cd94cc3d$var$weightRe.exec(substr)) font.weight = weight[1];
    if (style = $62a9fd43cd94cc3d$var$styleRe.exec(substr)) font.style = style[1];
    if (variant = $62a9fd43cd94cc3d$var$variantRe.exec(substr)) font.variant = variant[1];
    if (stretch = $62a9fd43cd94cc3d$var$stretchRe.exec(substr)) font.stretch = stretch[1];
    // Convert to device units. (`font.unit` is the original unit)
    // TODO: ch, ex
    switch(font.unit){
        case "pt":
            font.size /= 0.75;
            break;
        case "pc":
            font.size *= 16;
            break;
        case "in":
            font.size *= 96;
            break;
        case "cm":
            font.size *= 96.0 / 2.54;
            break;
        case "mm":
            font.size *= 96.0 / 25.4;
            break;
        case "%":
            break;
        case "em":
        case "rem":
            font.size *= $62a9fd43cd94cc3d$var$defaultHeight / 0.75;
            break;
        case "q":
            font.size *= 96 / 25.4 / 4;
            break;
    }
    return $62a9fd43cd94cc3d$var$cache[str] = font;
};

});


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


let $efd3ba4ec2608b1d$var$isDragging = false;
let $efd3ba4ec2608b1d$var$currentDragElement = null;
let $efd3ba4ec2608b1d$var$didDrag = false;
class $efd3ba4ec2608b1d$var$ColourEmitter extends EventTarget {
    changed() {
        this.dispatchEvent(new Event("colour-change"));
    }
}
const $efd3ba4ec2608b1d$var$colourEmitter = new $efd3ba4ec2608b1d$var$ColourEmitter();
function $efd3ba4ec2608b1d$var$openColorPicker(event) {
    if (event.detail > 1 || $efd3ba4ec2608b1d$var$didDrag) return;
    const colorPicker1 = document.getElementById("colorPicker");
    const colorLine = document.getElementById("colorLine");
    const xPosition = event.clientX - colorLine.getBoundingClientRect().left;
    $efd3ba4ec2608b1d$var$currentDragElement = null;
    colorPicker1.style.left = `${xPosition}px`;
    colorPicker1.setAttribute("data-xposition", xPosition);
    colorPicker1.click();
}
function $efd3ba4ec2608b1d$var$addPoint(color, xPosition) {
    let colorPoint;
    if ($efd3ba4ec2608b1d$var$currentDragElement) colorPoint = $efd3ba4ec2608b1d$var$currentDragElement;
    else {
        colorPoint = document.createElement("div");
        colorPoint.className = "colorPoint";
        colorPoint.style.left = `${xPosition}px`;
        colorPoint.addEventListener("dblclick", function() {
            this.remove();
        });
        colorPoint.addEventListener("mousedown", function(event) {
            $efd3ba4ec2608b1d$var$isDragging = true;
            $efd3ba4ec2608b1d$var$currentDragElement = this;
            $efd3ba4ec2608b1d$var$didDrag = false;
            document.addEventListener("mousemove", $efd3ba4ec2608b1d$var$onDrag);
            document.addEventListener("mouseup", $efd3ba4ec2608b1d$var$stopDrag);
        });
        colorPoint.addEventListener("click", function(event) {
            if ($efd3ba4ec2608b1d$var$didDrag) return;
            event.stopPropagation();
            if (event.shiftKey) {
                this.remove();
                $efd3ba4ec2608b1d$var$create();
                return;
            }
            $efd3ba4ec2608b1d$var$currentDragElement = this;
            colorPicker.style.display = "block";
            const hex = colorPoint.style.background.match(/\d+/g).map(Number).map((n)=>n.toString(16).padStart(2, "0")).join("");
            colorPicker.value = `#${hex}`;
            colorPicker.click();
        });
    }
    colorPoint.style.background = color;
    document.getElementById("colorLine").appendChild(colorPoint);
}
function $efd3ba4ec2608b1d$var$setColor(event) {
    const color = event.target.value;
    const xPosition = event.target.getAttribute("data-xposition");
    $efd3ba4ec2608b1d$var$addPoint(color, xPosition);
    $efd3ba4ec2608b1d$var$create();
}
function $efd3ba4ec2608b1d$var$onDrag(event) {
    if (!$efd3ba4ec2608b1d$var$isDragging) return;
    const colorLine = document.getElementById("colorLine");
    const xPosition = event.clientX - colorLine.getBoundingClientRect().left;
    if (xPosition >= 0 && xPosition <= colorLine.offsetWidth) {
        $efd3ba4ec2608b1d$var$currentDragElement.style.left = `${xPosition}px`;
        $efd3ba4ec2608b1d$var$didDrag = true;
        $efd3ba4ec2608b1d$var$create();
    }
}
function $efd3ba4ec2608b1d$var$stopDrag(event) {
    setTimeout(()=>{
        $efd3ba4ec2608b1d$var$isDragging = false;
        $efd3ba4ec2608b1d$var$didDrag = false;
    }, 200);
    document.removeEventListener("mousemove", $efd3ba4ec2608b1d$var$onDrag);
    document.removeEventListener("mouseup", $efd3ba4ec2608b1d$var$stopDrag);
    $efd3ba4ec2608b1d$var$create();
}
function $efd3ba4ec2608b1d$var$getPointsArray() {
    const colorPoints = document.querySelectorAll(".colorPoint");
    const colorLineWidth = document.getElementById("colorLine").offsetWidth;
    if (colorLineWidth === 0) return [];
    let pointsArray = [];
    for (let point of colorPoints){
        const t = parseInt(point.style.left, 10) / colorLineWidth;
        const rgb = point.style.background.match(/\d+/g).map(Number);
        pointsArray.push({
            c: rgb,
            t: t
        });
    }
    const array = pointsArray.sort((a, b)=>a.t - b.t);
    if (array.length === 1) array.push(array[0]);
    array[0].t = 0;
    array[array.length - 1].t = 1;
    return array;
}
const $efd3ba4ec2608b1d$var$pairs = (a)=>{
    const b = a.slice(1);
    return a.slice(0, -1).map((e, i)=>[
            e,
            b[i]
        ]);
};
function $efd3ba4ec2608b1d$var$rec(a, f, o = []) {
    const [h, ...t] = a;
    return h === undefined ? o : $efd3ba4ec2608b1d$var$rec(t, f, o.concat(f(h, o.slice(-1)[0], o.length)));
}
function $efd3ba4ec2608b1d$var$computeCubicSpline(ps) {
    const h = $efd3ba4ec2608b1d$var$pairs(ps).map(([a, b])=>b.x - a.x);
    const b = $efd3ba4ec2608b1d$var$pairs(ps).map(([a, b], i)=>(b.y - a.y) / h[i]);
    const u = $efd3ba4ec2608b1d$var$rec($efd3ba4ec2608b1d$var$pairs(h), ([a, b], l)=>2 * (a + b) - (l === undefined ? 0 : b * b / l));
    const v = $efd3ba4ec2608b1d$var$rec($efd3ba4ec2608b1d$var$pairs(b), ([a, b], l, i)=>6 * (b - a) - (l === undefined ? 0 : h[i] * l / u[i]));
    const z = Array(ps.length).fill(0);
    for(let i = ps.length - 2; i >= 1; i--)z[i] = (v[i - 1] - h[i] * z[i + 1]) / u[i - 1];
    return $efd3ba4ec2608b1d$var$pairs(ps).map(([p, q], i)=>{
        let a = p.y;
        let b = -h[i] / 6 * z[i + 1] - h[i] / 3 * z[i] + (q.y - p.y) / h[i];
        let c = z[i] / 2;
        let d = (z[i + 1] - z[i]) / (6 * h[i]);
        return {
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
}
function $efd3ba4ec2608b1d$var$cubicInterp(splines, points, x) {
    for(let i = 0; i < points.length - 1; i++)if (x > points[i].x && x < points[i + 1].x) {
        const { a: a, b: b, c: c, d: d } = splines[i];
        const dx = x - points[i].x;
        return a + dx * (b + dx * (c + d * dx));
    }
}
const $efd3ba4ec2608b1d$var$lerp = (p1, p2, t)=>{
    return p1.map((val, i)=>val + (p2[i] - val) * t);
};
function $efd3ba4ec2608b1d$var$interpolate(points, cubic) {
    if (cubic) {
        const cols = [
            0,
            1,
            2
        ].map((i)=>points.map((p)=>({
                    x: p.t,
                    y: p.c[i]
                })));
        const splines = cols.map($efd3ba4ec2608b1d$var$computeCubicSpline);
        const output = Array(256).fill(0).map((e, x)=>{
            return {
                c: splines.map((spline, i)=>$efd3ba4ec2608b1d$var$cubicInterp(spline, cols[i], x / 255))
            };
        });
        output[0].c = points[0].c;
        output[255].c = points[points.length - 1].c;
        return output;
    } else return points.slice(0, -1).flatMap((p, i)=>{
        const q = points[i + 1];
        const dt = q.t - p.t;
        const length = Math.ceil(dt * 255);
        const step = dt / length;
        return Array.from({
            length: length
        }, (_, j)=>{
            return {
                c: $efd3ba4ec2608b1d$var$lerp(p.c, q.c, j / length),
                t: p.t + j / length * dt
            };
        });
    });
}
function $efd3ba4ec2608b1d$var$xyzToRgb(x, y, z) {
    const toSRGB = (val)=>{
        val = val > 0.0031308 ? 1.055 * Math.pow(val, 1 / 2.4) - 0.055 : 12.92 * val;
        return Math.max(0, Math.min(255, Math.round(val * 255)));
    };
    const matrix = [
        [
            3.2404542,
            -1.5371385,
            -0.4985314
        ],
        [
            -0.969266,
            1.8760108,
            0.0415560
        ],
        [
            0.0556434,
            -0.2040259,
            1.0572252
        ]
    ];
    return matrix.map(([m1, m2, m3])=>toSRGB(m1 * x + m2 * y + m3 * z));
}
function $efd3ba4ec2608b1d$var$rgbToXyz(r, g, b) {
    const toLinear = (val)=>{
        val /= 255;
        return val > 0.04045 ? Math.pow((val + 0.055) / 1.055, 2.4) : val / 12.92;
    };
    [r, g, b] = [
        r,
        g,
        b
    ].map(toLinear);
    const matrix = [
        [
            0.4124564,
            0.3575761,
            0.1804375
        ],
        [
            0.2126729,
            0.7151522,
            0.0721750
        ],
        [
            0.0193339,
            0.1191920,
            0.9503041
        ]
    ];
    const [x, y, z] = matrix.map(([m1, m2, m3])=>m1 * r + m2 * g + m3 * b);
    return [
        x,
        y,
        z
    ];
}
const $efd3ba4ec2608b1d$var$wrap = (f, { p: p, c: c })=>({
        p: f(p),
        c: c
    });
let $efd3ba4ec2608b1d$var$customCM;
function $efd3ba4ec2608b1d$var$create() {
    const xyz = document.querySelector("#xyz").checked;
    const cubic = document.querySelector("#cubic").checked;
    if (xyz) {
        const xyz = $efd3ba4ec2608b1d$var$getPointsArray().map(({ c: c, t: t })=>({
                c: $efd3ba4ec2608b1d$var$rgbToXyz(...c),
                t: t
            }));
        $efd3ba4ec2608b1d$var$customCM = $efd3ba4ec2608b1d$var$interpolate(xyz, cubic).map(({ c: c, t: t })=>({
                c: $efd3ba4ec2608b1d$var$xyzToRgb(...c)
            }));
    } else $efd3ba4ec2608b1d$var$customCM = $efd3ba4ec2608b1d$var$interpolate($efd3ba4ec2608b1d$var$getPointsArray(), cubic);
    const div = document.querySelector("#cm");
    div.innerHTML = "";
    $efd3ba4ec2608b1d$var$customCM.forEach(({ c: c })=>{
        let e = document.createElement("div");
        const [r, g, b] = c;
        e.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
        div.appendChild(e);
    });
    const pointsArrayJSON = JSON.stringify($efd3ba4ec2608b1d$var$getPointsArray(), null, 2);
    document.querySelector("code").innerHTML = pointsArrayJSON;
    localStorage.setItem("pointsArray", pointsArrayJSON);
    $efd3ba4ec2608b1d$var$customCM = $efd3ba4ec2608b1d$var$customCM.map(({ c: c })=>[
            c[0] / 255,
            c[1] / 255,
            c[2] / 255
        ]);
    $efd3ba4ec2608b1d$var$colourEmitter.changed();
}
document.getElementById("colorLine").addEventListener("click", $efd3ba4ec2608b1d$var$openColorPicker);
document.getElementById("colorPicker").addEventListener("change", $efd3ba4ec2608b1d$var$setColor);
document.querySelector("#xyz").addEventListener("change", $efd3ba4ec2608b1d$var$create);
document.querySelector("#cubic").addEventListener("change", $efd3ba4ec2608b1d$var$create);
// const limits = [[0, 0], [255, 800]]
// limits.forEach(([c, v]) => {
//   addPoint(`rgb(${c}, ${c}, ${c})`, v)
// })
//
// addPoint('rgb(255, 0, 0)', 200)
// addPoint('rgb(0, 255, 0)', 500)
function $efd3ba4ec2608b1d$var$fromPointsArrayJSON(json) {
    document.getElementById("colorLine").innerHTML = "";
    for (const { c: c, t: t } of JSON.parse(json)){
        const [r, g, b] = c;
        $efd3ba4ec2608b1d$var$addPoint(`rgb(${r}, ${g}, ${b})`, t * 800);
    }
    $efd3ba4ec2608b1d$var$create();
}
const $efd3ba4ec2608b1d$var$existing = localStorage.getItem("pointsArray");
if ($efd3ba4ec2608b1d$var$existing) $efd3ba4ec2608b1d$var$fromPointsArrayJSON($efd3ba4ec2608b1d$var$existing);
else {
    $efd3ba4ec2608b1d$var$addPoint("rgb(147, 105, 31)", 0);
    $efd3ba4ec2608b1d$var$addPoint("rgb(142, 107, 47)", 90);
    $efd3ba4ec2608b1d$var$addPoint("rgb(217, 175, 58)", 240);
    $efd3ba4ec2608b1d$var$addPoint("rgb(210, 163, 81)", 462);
    $efd3ba4ec2608b1d$var$addPoint("rgb(255, 255, 255)", 800);
    $efd3ba4ec2608b1d$var$create();
}
document.querySelector("#set-colour-points").addEventListener("click", ()=>{
    $efd3ba4ec2608b1d$var$fromPointsArrayJSON(window.prompt("colour codes:"));
});

var $fboOs = parcelRequire("fboOs");
const $efd3ba4ec2608b1d$var$usingBrowser = typeof window === "object";
const $efd3ba4ec2608b1d$var$clamp = (l, m = 230)=>l.map((e)=>Math.floor(Math.max(0, Math.min(255, e * m))));
const $efd3ba4ec2608b1d$var$s2 = (q, p, k)=>{
    const s = p[`s_${k}`], b = p[`b_${k}`];
    return q[k].map((v)=>v * v / (1 + s * v * v) + b);
};
const $efd3ba4ec2608b1d$var$dcy = (q, p, k)=>{
    const l = q[k], D = p[`D_${k}`], r = p[`r_${k}`];
    return l.map((v, i)=>D * ((i === 0 ? v : l[i - 1]) - 2 * v + (i === l.length - 1 ? v : l[i + 1])) - r * v);
};
function $efd3ba4ec2608b1d$var$iter(q, p) {
    const [as2, cs2] = [
        "a",
        "c"
    ].map((c)=>$efd3ba4ec2608b1d$var$s2(q, p, c));
    const [da, db, dc, dd] = [
        "a",
        "b",
        "c",
        "d"
    ].map((c)=>$efd3ba4ec2608b1d$var$dcy(q, p, c));
    q.a = q.a.map((a, i)=>a + p.s * q.c[i] * q.b[i] * as2[i] + da[i]);
    q.b = q.b.map((b, i)=>b + p.b_b - p.s * q.c[i] * b * as2[i] + db[i]);
    q.c = q.c.map((c, i)=>c + p.r_c * (cs2[i] / (q.d[i] + p.c_c * q.b[i] + p.s_e * q.e[i])) + dc[i]);
    q.d = q.d.map((d, i)=>d + p.r_c * cs2[i] + dd[i]);
    q.e = q.e.map((e, i)=>e + p.b_e * q.c[i] - p.r_e * e);
}
const $efd3ba4ec2608b1d$var$genp = (pre, subs)=>Object.fromEntries(Array.from(subs).map((k)=>[
            `${pre}_${k}`,
            1
        ]));
const $efd3ba4ec2608b1d$var$p = {
    s: 0.12,
    iterations: 7
};
Object.assign($efd3ba4ec2608b1d$var$p, $efd3ba4ec2608b1d$var$genp("D", "abcd"));
Object.assign($efd3ba4ec2608b1d$var$p, $efd3ba4ec2608b1d$var$genp("r", "abcde"));
Object.assign($efd3ba4ec2608b1d$var$p, $efd3ba4ec2608b1d$var$genp("b", "abce"));
Object.assign($efd3ba4ec2608b1d$var$p, $efd3ba4ec2608b1d$var$genp("s", "abce"));
Object.assign($efd3ba4ec2608b1d$var$p, $efd3ba4ec2608b1d$var$genp("c", "bc"));
$efd3ba4ec2608b1d$var$p.D_a = 0.05;
$efd3ba4ec2608b1d$var$p.D_b = 0.1;
$efd3ba4ec2608b1d$var$p.D_c = 0.01;
$efd3ba4ec2608b1d$var$p.D_d = 0;
$efd3ba4ec2608b1d$var$p.r_a = 0.12;
$efd3ba4ec2608b1d$var$p.r_b = 0.003;
$efd3ba4ec2608b1d$var$p.r_c = 0.04;
$efd3ba4ec2608b1d$var$p.r_d = 0.05;
$efd3ba4ec2608b1d$var$p.r_e = 0.002;
$efd3ba4ec2608b1d$var$p.b_a = 0.01;
$efd3ba4ec2608b1d$var$p.b_b = 0.06;
$efd3ba4ec2608b1d$var$p.b_c = 0.0;
$efd3ba4ec2608b1d$var$p.b_e = 0.002;
$efd3ba4ec2608b1d$var$p.s_a = 1;
$efd3ba4ec2608b1d$var$p.s_b = 0.0;
$efd3ba4ec2608b1d$var$p.s_c = 0.4;
$efd3ba4ec2608b1d$var$p.s_e = 0.08;
$efd3ba4ec2608b1d$var$p.c_b = 0;
$efd3ba4ec2608b1d$var$p.c_c = 0.002;
function $efd3ba4ec2608b1d$var$randomiseParams() {
    for(const k in $efd3ba4ec2608b1d$var$p){
        const a = 1;
        if (k != "iterations") {
            const b = $efd3ba4ec2608b1d$var$p[k];
            $efd3ba4ec2608b1d$var$p[k] *= 1 + Math.random() * a - a / 2;
            $efd3ba4ec2608b1d$var$p[k] = Math.max(0, $efd3ba4ec2608b1d$var$p[k]);
        }
    }
}
// const rand = Array(N).fill(0).map(e => Array(N).fill(0).map(f => Math.random()))
let $efd3ba4ec2608b1d$var$q = null;
let $efd3ba4ec2608b1d$var$qbak = null;
function $efd3ba4ec2608b1d$var$draw(canvas, exportCanvas, cmn) {
    const ctx = canvas.getContext("2d", {
        willReadFrequently: true
    });
    const w = canvas.offsetWidth, h = canvas.offsetHeight, n = w * h;
    const data = ctx.getImageData(0, 0, w, h);
    const N = canvas.offsetWidth;
    if (!$efd3ba4ec2608b1d$var$q) {
        $efd3ba4ec2608b1d$var$q = {
            // a: Array(N).fill(0).map((v, i) => Math.sin(i*0.05) * 0.5 + 0.5),
            a: Array(N).fill(0).map((v, i)=>Math.random()),
            b: Array(N).fill(0).map(()=>Math.random()),
            // c: Array(N).fill(0).map((v, i) => Math.sin(i*0.05) * 0.5 + 0.5),
            c: Array(N).fill(0).map((v, i)=>Math.random()),
            d: Array(N).fill(0).map(()=>Math.random()),
            e: Array(N).fill(0).map(()=>Math.random())
        };
        $efd3ba4ec2608b1d$var$qbak = JSON.stringify($efd3ba4ec2608b1d$var$q);
    } else $efd3ba4ec2608b1d$var$q = JSON.parse($efd3ba4ec2608b1d$var$qbak);
    if (!cmn) cmn = document.querySelector("#colormaps").selectedOptions[0].value;
    const cm = cmn === "custom" ? $efd3ba4ec2608b1d$var$customCM : $fboOs[cmn];
    const pixels = data.data;
    let k, v, vv, z;
    const output = [];
    let col1, col2, ectx, exportData, exportPixels;
    if (exportCanvas) {
        const toCol = (v)=>[
                0,
                1,
                2
            ].map((i)=>parseInt(v.substr(i * 2 + 1, 2), 16));
        col1 = toCol(document.querySelector("#col1").value);
        col2 = toCol(document.querySelector("#col2").value);
        ectx = exportCanvas.getContext("2d", {
            willReadFrequently: true
        });
        exportData = ectx.getImageData(0, 0, 200, 200);
        exportPixels = exportData.data;
    }
    const start = +new Date();
    // console.log('cm', cm)
    for(let y = 0; y < h; y++){
        for(let j = 0; j < $efd3ba4ec2608b1d$var$p.iterations; j++)$efd3ba4ec2608b1d$var$iter($efd3ba4ec2608b1d$var$q, $efd3ba4ec2608b1d$var$p);
        v = $efd3ba4ec2608b1d$var$clamp($efd3ba4ec2608b1d$var$q.a);
        if (y > 10) output.push(v);
        for(let x = 0; x < w; x++){
            k = (x + y * w) * 4;
            vv = v[x];
            const [r, g, b] = cm[vv];
            pixels[k] = r * 255;
            pixels[k + 1] = g * 255;
            pixels[k + 2] = b * 255;
            pixels[k + 3] = 255;
            if (exportCanvas && x % 2 == 0 && y % 2 === 0) {
                k = (x / 2 + y / 2 * 200) * 4;
                const c = vv < 127 ? col1 : col2;
                exportPixels[k] = c[0];
                exportPixels[k + 1] = c[1];
                exportPixels[k + 2] = c[2];
                exportPixels[k + 3] = 255;
            }
        }
    }
    const took = +new Date() - start;
    console.log("took", took);
    ctx.putImageData(data, 0, 0);
    if (exportCanvas) ectx.putImageData(exportData, 0, 0);
    return output;
}
function $efd3ba4ec2608b1d$var$std(numbers) {
    const n = numbers.length;
    const mean = numbers.reduce((sum, num)=>sum + num, 0) / n;
    const squaredDifferences = numbers.map((num)=>Math.pow(num - mean, 2));
    const variance = squaredDifferences.reduce((sum, squaredDiff)=>sum + squaredDiff, 0) / n;
    return Math.sqrt(variance);
}


if ($efd3ba4ec2608b1d$var$usingBrowser) {
    const { hash: hash } = window.location;
    if (hash) {
        const d = JSON.parse(atob(hash.substring(1)));
        Object.assign($efd3ba4ec2608b1d$var$p, d);
    }
    const select = document.querySelector("#colormaps");
    Object.keys($fboOs).forEach((cm)=>{
        const option = document.createElement("option");
        option.text = option.value = cm;
        select.add(option);
    });
    const option = document.createElement("option");
    option.text = option.value = "custom";
    select.add(option);
    select.value = "twilight";
    const canvas = document.querySelector("canvas.main");
    const exportCanvas = document.querySelector("canvas.export");
    window.addEventListener("load", ()=>$efd3ba4ec2608b1d$var$draw(canvas, exportCanvas));
    select.addEventListener("change", ({ target: target })=>{
        document.querySelector("#colours").style.display = target.value === "custom" ? "flex" : "none";
        $efd3ba4ec2608b1d$var$create();
        $efd3ba4ec2608b1d$var$draw(canvas, exportCanvas);
    });
    $efd3ba4ec2608b1d$var$colourEmitter.addEventListener("colour-change", (e)=>{
        $efd3ba4ec2608b1d$var$draw(canvas, exportCanvas);
    });
    document.querySelector("#col1").addEventListener("change", ()=>$efd3ba4ec2608b1d$var$draw(canvas, exportCanvas));
    document.querySelector("#col2").addEventListener("change", ()=>$efd3ba4ec2608b1d$var$draw(canvas, exportCanvas));
    const controls = document.querySelector("div.controls");
    Object.keys($efd3ba4ec2608b1d$var$p).forEach((param)=>{
        const control = document.createElement("div");
        control.classList.add("control", param);
        const input = document.createElement("input");
        input.type = "range";
        input.name = param;
        input.value = $efd3ba4ec2608b1d$var$p[param] * (param === "iterations" ? 1 : 100);
        input.max = param === "iterations" ? 10 : 100;
        input.step = param === "iterations" ? 1 : 0.1;
        control.appendChild(input);
        const label = document.createElement("label");
        label.innerHTML = `${param} (${$efd3ba4ec2608b1d$var$p[param].toFixed(3)})`;
        control.appendChild(label);
        controls.appendChild(control);
    });
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input)=>{
        input.addEventListener("input", ({ target: target })=>{
            const { name: name, value: value } = target;
            if (name) {
                const label = document.querySelector(`div.${name} label`);
                $efd3ba4ec2608b1d$var$p[name] = value * (name === "iterations" ? 1 : 0.01);
                const s = name === "iterations" ? $efd3ba4ec2608b1d$var$p[name] : $efd3ba4ec2608b1d$var$p[name].toFixed(3);
                label.innerHTML = `${name} (${s})`;
                $efd3ba4ec2608b1d$var$draw(canvas, exportCanvas);
            }
        });
    });
    document.querySelector("#export").addEventListener("click", ()=>{
        const img = exportCanvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = img;
        a.download = "sea-shell-pattern.png";
        a.click();
    });
} else {
    const fs = (parcelRequire("c34FY"));
    const { createCanvas: createCanvas } = (parcelRequire("dTAXV"));
    const canvas = createCanvas(50, 50);
    canvas.offsetWidth = canvas.width;
    canvas.offsetHeight = canvas.height;
    const random = Math.random().toString(30).substring(2);
    const out = fs.createWriteStream(`./outputs/${random}.png`);
    const stream = canvas.createPNGStream();
    stream.pipe(out);
    let attempts = 1;
    while(true){
        $efd3ba4ec2608b1d$var$randomiseParams();
        const pix = $efd3ba4ec2608b1d$var$draw(canvas, false, "bw");
        const meanStd = pix.map($efd3ba4ec2608b1d$var$std).reduce((sum, num)=>sum + num, 0) / pix.length;
        $cfae44f0dfdf62c0$exports.stdout.write(`\rattempt ${attempts}: ${meanStd}`);
        attempts++;
        if (meanStd > 20) {
            console.log();
            break;
        }
    }
    fs.writeFileSync(`./outputs/${random}.json`, JSON.stringify($efd3ba4ec2608b1d$var$p, null, 2));
    console.log("created", random);
}


//# sourceMappingURL=index.123aaefa.js.map
